// extracted by mini-css-extract-plugin
export default {"widgetMetric":"abandonStats_widgetMetric__BkC6p"};